module.exports = __webpack_public_path__ + "img/mantraz-icon.58f4f098.svg";